// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"841":"3044af45","1193":"3044af45","1227":"3044af45","3488":"3044af45","3971":"27598b0e","5281":"7ac6a1a1","6327":"3044af45","7933":"a8c921bc","8489":"3044af45","9407":"3044af45"}[chunkId] + ".chunk.css";
};